export class DeleteGdsgObjectsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "results",
            "baseName": "results",
            "type": "Array<GdsgDeleteResult>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DeleteGdsgObjectsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
